import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

const PipelinesRepoOpenIDPageLoadable = Loadable<any, never>({
  loading: LoadingPage,
  loader: () => import('./openid'),
});

// eslint-disable-next-line import/no-default-export
export default PipelinesRepoOpenIDPageLoadable;
